import { BreadcrumbData, BreadcrumbItem } from '@/components/breadcrumbs';
import { UserPermission } from '@/modules/Permissions/Permissions.constants';

/**
 * Filters breadcrumbs based on user permissions.
 *
 * @param breadcrumbs - The original breadcrumb items.
 * @returns Filtered breadcrumbs.
 */
export const filterBreadcrumbs = (
  breadcrumbs: BreadcrumbItem[],
  hasPermission: (permission: UserPermission) => boolean
): BreadcrumbItem[] => {
  return breadcrumbs.filter(({ permission }) => {
    return hasPermission(permission); // Allow if no permission is required or user has the required permissions
  });
};

export const createBreadcrumbs = (data: BreadcrumbData, hasPermission: (permission: UserPermission) => boolean): BreadcrumbItem[] => {
  const breadcrumbs: BreadcrumbItem[] = [
    {
      title: 'Customers',
      permission: 'PERMISSION_CUSTOMER_LIST',
      path: `/customers`,
      isLast: false,
    },
  ];

  if (data.client?.id) {
    breadcrumbs.push({
      title: data.client.name || data.client.id,
      permission: 'PERMISSION_CUSTOMER_LIST',
      path: `/customers/${data.client.id}/projects/`,
      isLast: data.project ? false : true,
    });
    if (data.project?.id) {
      breadcrumbs.push({
        title: data.project.name || data.project.id,
        permission: 'PERMISSION_PROJECT_LIST',
        path: `/customers/${data.client.id}/projects/${data.project.id}/farms`,
        isLast: data.farm ? false : true,
      });
      if (data.farm?.id) {
        breadcrumbs.push({
          title: data.farm.name || data.farm.id,
          permission: 'PERMISSION_FARM_LIST',
          path: `/customers/${data.client.id}/projects/${data.project.id}/farms/${data.farm.id}/`,
          isLast: data.field ? false : true,
        });
        if (data.field?.id) {
          breadcrumbs.push({
            title: data.field.id,
            permission: 'PERMISSION_FARM_DETAIL_COMPLETE',
            path: `/customers/${data.client.id}/projects/${data.project.id}/farms/${data.farm.id}/fields/${data.field.id}`,
            isLast: true,
          });
        }
      }
    }
  }

  // Set the last item’s (current page) path to undefined
  if (breadcrumbs.length > 0 && breadcrumbs[breadcrumbs.length - 1] !== undefined) {
    const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
    if (lastBreadcrumb) {
      lastBreadcrumb.path = undefined;
    }
  }

  // Filter by permissions
  return filterBreadcrumbs(breadcrumbs, hasPermission);
};
